<template>
  <CustomTitleBar title="商品详情" />
  <div class="page-content">
    <div class="detail-content">
      <el-carousel :interval="4000" arrow="always">
        <el-carousel-item v-for="(item, index) in detail.images" :key="index">
          <img :src="baseUrl + item" alt="商品图片" />
        </el-carousel-item>
      </el-carousel>

      <div class="detail-info">
        <div class="detail-info-price">
          <span class="current-price">¥{{ detail.price }}</span>
          <span class="original-price">¥{{ detail.originalPrice }}</span>
        </div>
        <div class="detail-info-title">{{ detail.detailTitle }}</div>
        <div class="service-info">
          <span>支持7天无理由退换</span>
          <span>&gt;</span>
        </div>
        <div class="detail-info-html" v-html="detail.detailHtml"></div>
      </div>
    </div>
    <div class="pay-btn-wrap">
      <span class="price">￥{{ detail.price }}</span>
      <div class="pay-btn" @click="goPay">立即购买</div>
    </div>
  </div>

  <van-dialog v-model:show="showPaymentDialog" title="订单确认" @confirm="handleConfirm"
    @cancel="showPaymentDialog = false">
    <template #default>
      <div class="dialog-content">
        <img :src="baseUrl + detail.picture" alt="商品图片" />
        <div class="dialog-content-info">
          <span class="title">{{ detail.detailTitle }}</span>
          <div class="price-wrap">
            <span class="price">￥{{ detail.price * quantity }}</span>
            <van-stepper v-model="quantity" :min="1" />
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="dialog-footer">
        <div class="cancel-btn" @click="showPaymentDialog = false">取消</div>
        <div class="confirm-btn" @click="handleConfirm">去支付</div>
      </div>
    </template>
  </van-dialog>
</template>
<script lang="ts" setup>
import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { onMounted } from "vue";
import { ref } from "vue";
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

const baseUrl = process.env.VUE_APP_IMG_BASE_URL;
const detail = ref<any>({});
const showPaymentDialog = ref(false);
const quantity = ref(1);

const handleConfirm = () => {
  router.push({
    path: '/Pay',
    query: {
      amount: detail.value.price * quantity.value,
      goodsId: detail.value.id,
      goodsTitle: detail.value.title
    }
  })
}

onMounted(() => {
  if (route.query.item) {
    detail.value = JSON.parse(route.query.item as string);
    if (detail.value.picture) {
      detail.value.images = [detail.value.picture]
    }
    if (detail.value.albumPics) {
      detail.value.images.push(...detail.value.albumPics.split(','));
    }
  }
  console.log(detail.value);
})

const goPay = () => {
  showPaymentDialog.value = true;
}
</script>
<style lang="scss" scoped>
.page-content {
  padding-top: 44px;
  overflow: hidden;
  background: #fff;

  :deep(.el-carousel) {
    width: 100%;

    .el-carousel__item {
      img {
        width: 100%;
        height: 300px;
        object-fit: cover;
      }
    }
  }
}

.pay-btn-wrap {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  background: #fff;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .price {
    font-size: 28px;
    font-weight: bold;
    color: #FA5151;
  }

  .pay-btn {
    position: relative;
    width: 60%;
    height: 40px;
    background: #FA5151;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
  }
}

.dialog-content {
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;

  img {
    width: 80px;
    height: 80px;
  }

  .dialog-content-info {
    margin-left: 16px;
    width: calc(100% - 80px - 16px);
    height: 80px;
    display: flex;
    flex-direction: column;

    .title {
      margin-bottom: 10px;
      color: #9E9E9E;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .price-wrap {
    display: flex;
    align-items: center;

    .price {
      margin-right: 16px;
      font-size: 14px;
      color: #FA5151;
    }
  }
}

.dialog-footer {
  padding: 0 20px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .cancel-btn {
    width: calc(50% - 10px);
    height: 50px;
    background: #9E9E9E;
    color: #000;
    font-weight: 500;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .confirm-btn {
    width: calc(50% - 10px);
    height: 50px;
    background: #FA5151;
    color: #fff;
    font-weight: 500;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;

  }
}

.detail-info {
  padding: 16px 16px 80px;
  box-sizing: border-box;

  .detail-info-price {
    margin-bottom: 10px;

    .current-price {
      color: #ff4400;
      font-size: 24px;
      font-weight: bold;
    }

    .original-price {
      color: #999;
      font-size: 14px;
      text-decoration: line-through;
      margin-left: 8px;
    }
  }

  .detail-info-title {
    font-size: 18px;
    font-weight: 600;
    color: #111111;
    margin: 10px 0;
  }

  .service-info {
    padding: 10px 0;
    background: #fff;
    margin-bottom: 10px;
    font-size: 14px;
    color: #666;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .detail-info-html {
    width: 100%;

    :deep p {
      width: 100%;

      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
